import React from 'react';

const PropsInput = ({ value, onChange, isValid }) => {
    const handleChange = (event) => {
        let rawValue = event.target.value.replace(/\D/g, '');

        let formattedValue = rawValue;
        if (rawValue.length > 14) {
            formattedValue = rawValue.replace(/(\d{14})(\d{1,8})?/, '$1/$2');
        }

        formattedValue = formattedValue.replace(/\/$/, '');

        onChange(formattedValue);
    };

    return (
        <input
            type="text"
            value={value}
            onChange={handleChange}
            maxLength={23}
            placeholder="12345678901234/12345678"
            style={{ border: isValid ? '1px solid #ccc' : '1px solid red' }}
        />
    );
};

export default PropsInput;
